module.exports = __webpack_public_path__ + "img/SOL.8f48b6e8.svg";